// extracted by mini-css-extract-plugin
export default {"iconBase":"PlusIcon_iconBase__i6pc2"};